import { CloseButton, Col, Modal, Row, Stack } from "react-bootstrap"
import { TextButton } from "Components/Button";
import WarningIcon from "@mui/icons-material/WarningAmberRounded";

const ConfirmSavePSOHistoryPopup = ({
                                    show,
                                    handleClose,
                                    handleDownload
                                  }) => {

  const cancel = () => {
    handleClose();
  }

  const downloadAnnualHistory = () => {
    handleDownload();
    handleClose();
  }

  return (

    <Modal className="modal" size="lg" backdrop="static" show={show}>
      <Modal.Header className="m-3">
        <Modal.Title >Confirm</Modal.Title>
        <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
      </Modal.Header>
      <Modal.Body>
        <Stack direction="horizontal" className="page-info--warning">
          <div className="icon-container">
            <WarningIcon fontSize="small"></WarningIcon>
          </div>
          <div className="message">
            Are you sure to save PSO history information for current reporting year?
          </div>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Row className="mb-4 float-end">
          <Col lg={4}>
            <Stack className="pt-3" direction="horizontal" gap={3}>
              <TextButton
                variant="normal"
                onClick={downloadAnnualHistory}
                content={"Yes"}
              >
              </TextButton>
            </Stack>
          </Col>
          <Col>
            <Stack className="pt-3 float-end" direction="horizontal" gap={3}>
              <TextButton
                variant="outline"
                onClick={cancel}
                content={"No"}
              >
              </TextButton>
            </Stack>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>



  )


}

export default ConfirmSavePSOHistoryPopup;